import React, { Component } from "react";
import { ErrorList, FormSection } from "src/react/forms/styles";

export class ErrorStatus extends Component {
  render() {
    const { status } = this.props;
    if (!status || !status.error) return null;
    return (
      <FormSection data-selector="ErrorStatus">
        <ErrorList>
          <li>{status.error}</li>
        </ErrorList>
      </FormSection>
    );
  }
}
